export default __webpack_public_path__ + "static/mobile-anxiety-a0de805b79d78f826735937f9d1a2ee8.webp";